import DistributionsScheduleForm from "./DistributionsScheduleForm"

export default DistributionsScheduleForm
